(function () {
  'use strict';

  var SECTION_SELECTOR = '.wb-pf';
  var prefersReduced   = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initParallax(section) {
    if (prefersReduced) return;

    var img = section.querySelector('[data-parallax-img]');
    if (!img) return;

    var rafId = null;
 
    img.style.willChange = 'transform';

    function update() {
      var rect     = section.getBoundingClientRect();
      var vh       = window.innerHeight;
      var progress = (vh - rect.top) / (vh + rect.height);
      var offset   = (progress - 0.5) * rect.height * 0.18;
      img.style.transform = 'translate3d(0, ' + offset + 'px, 0)';
      rafId = null;
    }

    function onScroll() {
      if (rafId) return;
      rafId = requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    update();

    section._parallaxCleanup = function () {
      window.removeEventListener('scroll', onScroll);
      if (rafId) cancelAnimationFrame(rafId);
      img.style.willChange = '';
    };
  }

  function initSection(section) {
    var entries = section.querySelectorAll('.wb-anim-entry');

    if (prefersReduced) {
      entries.forEach(function (el) { el.classList.add('in-view'); });
    } else {
      var observer = new IntersectionObserver(function (items) {
        items.forEach(function (item) {
          if (item.isIntersecting) {
            item.target.classList.add('in-view');
            observer.unobserve(item.target);
          }
        });
      }, { threshold: 0.08 });

      entries.forEach(function (el) {
        if (el.classList.contains('none')) {
          el.classList.add('in-view');
        } else {
          observer.observe(el);
        }
      });
    }

    if (section.dataset.parallax === 'true' && section.dataset.mode === 'background') {
      initParallax(section);
    }
  }

  function init() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.querySelector(SECTION_SELECTOR);
    if (section && section._parallaxCleanup) section._parallaxCleanup();
  });

})();